module.exports = __webpack_public_path__ + "static/media/playerLoading.dab98cdc.svg";